import { NavLink, useLocation } from "react-router-dom";
import { useCart } from "../../../app/context/cart-context/cart-context";
import { useEffect, useState } from "react";

import './footer.css'

import { ReactComponent as CartIcon } from "../../../assets/images/icons/cart.svg";
import { ReactComponent as MenuIcon } from "../../../assets/images/icons/menu.svg";
import { ReactComponent as HistoryIcon } from "../../../assets/images/icons/history.svg";

export const Footer = () => {
    const { cart } = useCart();

    const  location = useLocation();

    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const cartCount = cart.length;
        if (cartCount !== 0) {
            setCounter(cartCount)
        } else {
            setCounter(0)
        }
        
    }, [cart]);
    
    const isMenu = location.pathname.includes('/category/') || location.pathname.includes('/product/')  || location.pathname.includes('/search');

    const isCart = location.pathname.includes('/shipping') || location.pathname.includes('/checkout');
    
    return (
        <footer>
            <ul className="nav justify-content-center">
                <li className="nav-item">
                    <NavLink 
                        to='/' 
                        className={`nav-link сustom ${isMenu ? 'active' : ''}`}
                        >
                        <MenuIcon/>
                        <span>Меню</span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/cart' className={`nav-link сustom ${isCart ? 'active' : ''}`}>
                        {counter !== 0 &&
                            <div className="cart-counter">{counter}</div>
                        }
                        <CartIcon/>                       
                        <span>Кошик</span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/history' className={`nav-link сustom`}>
                        <HistoryIcon/>
                        <span>Замовлення</span>
                    </NavLink>
                </li>
                {/* <li className="nav-item">
                    <NavLink to='/setting' className={`nav-link`}>Налаштування</NavLink>
                </li> */}
            </ul>
        </footer>
    )
}